import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const steps = [
  {
    number: "01",
    title: "Consultation",
    description: "We learn about your current situation, challenges and financial goals.",
    testId: "step-consultation",
  },
  {
    number: "02",
    title: "Education",
    description:
      "We explain relevant credit, financial and funding concepts so you understand the factors involved.",
    testId: "step-education",
  },
  {
    number: "03",
    title: "Personalized Roadmap",
    description:
      "Based on your individual circumstances, we help you organize priorities and create an educational action plan.",
    testId: "step-roadmap",
  },
  {
    number: "04",
    title: "Mentorship",
    description:
      "Continue learning while receiving guidance, accountability and educational resources.",
    testId: "step-mentorship",
  },
];

export const HowItWorks = () => (
  <section id="how-it-works" data-testid="how-it-works-section" className="scroll-mt-24 bg-[#141419] py-14 lg:py-20">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center">
        <p className="text-[11px] font-bold uppercase tracking-[0.24em] text-[#D8B54A]" data-testid="how-it-works-label">
          How It Works
        </p>
        <h2
          data-testid="how-it-works-heading"
          className="mx-auto mt-3 max-w-2xl font-heading text-2xl font-bold tracking-tight text-[#F2EEE3] sm:text-3xl lg:text-4xl"
        >
          A Clearer Path Forward.
        </h2>
      </Reveal>
      <div className="relative mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {steps.map((step, i) => (
          <Reveal key={step.number} delay={i * 0.1}>
            <div
              data-testid={step.testId}
              className="group h-full rounded-2xl border border-white/10 bg-[#17171C] p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:shadow-black/40"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#08080A] font-heading text-base font-bold text-white shadow-md shadow-black/40">
                {step.number}
              </span>
              <h3 className="mt-6 font-heading text-lg font-semibold tracking-tight text-[#F2EEE3]">{step.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#B8B2A6]">{step.description}</p>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2} className="mt-10 text-center">
        <Link
          to="/#consultation"
          data-testid="how-it-works-cta"
          className="group inline-flex h-12 items-center justify-center gap-2 rounded-lg bg-gradient-to-b from-[#E7C766] to-[#AE8924] px-8 text-sm font-semibold text-black shadow-md shadow-[#C9A227]/20 transition-colors duration-200 hover:from-[#F2D47E] hover:to-[#C49B2E]"
        >
          Schedule Your Consultation
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </Reveal>
    </div>
  </section>
);
